import { useEffect } from 'react';

/**
 * useEventListener - Hook used to bind eventListeners.
 *
 * @param {string} eventName - Event name listening to.
 * @param {function} handler - Function called when event listener is triggered.
 * @param {HTMLElement=} element - Optional element to listen on.
 *
 * @example
 * const MyComponent = () => {
 *    const ref = useRef();
 *    useEventListener("keydown", (e) => {
 *      if (e.keyCode !== 39) {
 *         return;
 *      }
 *      ref.current.click();
 *    });
 *    return (
 *      <a href="https://lessonly.com" ref={ref}>Go to Lessonly (when right arrow is clicked)</a>
 *     )
 * };
 *
 */

const useEventListener = (eventName, handler, element = window) => {
  useEffect(() => {
    const eventListener = element.addEventListener(eventName, handler);
    return () => {
      element.removeEventListener(eventName, eventListener);
    };
  }, [element, eventName, handler]);
};

export default useEventListener;
